import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { InfoCard, Link } from '@backstage/core-components';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  SEVERITY_COLORS,
  SEVERITY_MARKS,
  issueText,
  useEntityTemporal,
} from '../health/api';

const useStyles = makeStyles(theme => ({
  cell: { padding: theme.spacing(0.5, 1) },
  name: { fontFamily: 'monospace', fontSize: 12, wordBreak: 'break-all' },
  issue: { fontSize: 13, marginBottom: theme.spacing(0.5) },
  section: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    fontWeight: 600,
  },
  failure: { fontSize: 12, padding: theme.spacing(0.25, 0) },
  muted: { color: theme.palette.text.secondary },
}));

const formatDate = (iso?: string) =>
  iso
    ? new Date(iso).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '';

export const TemporalCard = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const { value } = useEntityTemporal(stringifyEntityRef(entity));
  if (!value?.queues.length) return null;

  const cell = classes.cell;
  const failures = value.queues
    .flatMap(q => q.recentFailures.map(f => ({ ...f, queue: q.name })))
    .sort((a, b) => (b.closedAt ?? '').localeCompare(a.closedAt ?? ''))
    .slice(0, 5);

  return (
    <Grid item md={6} xs={12}>
      <InfoCard title="Temporal">
        {value.issues?.map((i, n) => (
          <Typography
            key={n}
            className={classes.issue}
            style={{ color: SEVERITY_COLORS[i.severity] }}
          >
            {SEVERITY_MARKS[i.severity]} {issueText(i)}
          </Typography>
        ))}
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={cell}>Task queue</TableCell>
              <TableCell className={cell} align="right">
                Воркеры
              </TableCell>
              <TableCell className={cell} align="right">
                Бэклог
              </TableCell>
              <TableCell className={cell} align="right">
                Идут
              </TableCell>
              <TableCell className={cell} align="right">
                Упали за сутки
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {value.queues.map(q => (
              <TableRow key={q.name}>
                <TableCell className={`${cell} ${classes.name}`}>
                  {q.name}
                </TableCell>
                <TableCell className={cell} align="right">
                  {q.pollers.workflow + q.pollers.activity}
                </TableCell>
                <TableCell className={cell} align="right">
                  {q.backlog}
                </TableCell>
                <TableCell className={cell} align="right">
                  {q.running}
                </TableCell>
                <TableCell className={cell} align="right">
                  {q.failed24h}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {failures.length > 0 && (
          <>
            <Typography className={classes.section}>
              Последние упавшие
            </Typography>
            {failures.map(f => (
              <div
                key={`${f.queue}/${f.workflowId}`}
                className={classes.failure}
              >
                {f.url ? (
                  <Link to={f.url}>{f.workflowType}</Link>
                ) : (
                  f.workflowType
                )}{' '}
                <span className={classes.muted}>
                  {f.status} · {formatDate(f.closedAt)} · {f.workflowId}
                </span>
              </div>
            ))}
          </>
        )}
      </InfoCard>
    </Grid>
  );
};
